import { useQuery, useMutation, useQueryClient } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function useFeatures(params) {
  const { data, ...rest } = useQuery('features', () =>
    apiCalls.getFeatures(params).then(({ data: { features } }) => features)
  );
  return { features: data, ...rest };
}

export function useFeatureEdit() {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(
    ({ feature }) => apiCalls.editFeature({ feature }).then(({ data: { feature } }) => feature),
    {
      onSuccess: (feature) => {
        queryClient.invalidateQueries('features');
        return feature;
      },
    }
  );
  return { editFeature: mutate, ...rest };
}
